import { Injectable } from '@angular/core';
import { Md5 } from 'ts-md5/dist/md5';
import { PassCard, WMSToken, itmMenu } from '../../models/auth-data.model';
import { AjustesProvider } from '../ajustes/ajustes';
import { catAccionesPorModulo } from '../../models/catalogos/catAccionesPorModulo-data.model';
import { MensajesProvider } from '../mensajes/mensajes';
import { HttpApiProvider } from '../http-api/http-api';
import { Observable } from 'rxjs';
import { NavController } from '@ionic/angular';
import { LocalDataService } from '../almacenamiento/local-data.service';

import { map, catchError } from 'rxjs/operators'; // Asegúrate de importar estos operadores
import { CryptoProvider } from '../cifrado/AesCipher'

@Injectable({
  providedIn: 'root'
})
export class AuthProvider {
  public passCard: PassCard = undefined;

  constructor(
    private ajustesProvider: AjustesProvider,
    private navCtrl: NavController,
    private httpApiService: HttpApiProvider,
    private mensajesService: MensajesProvider,
    private localDataService: LocalDataService,
    private CryptoProvider: CryptoProvider,
  ) {

    if (this.passCard) {
      this.passCard.LstModulos =
        [{
          title: 'Principal',
          IdCategoriaModulo: 1,
          strCategoriaModulo: 'Operación ',
          component: 'DefaultPage',
          strIcono: 'logo-buffer',
          selected: false
        }];
      this.passCard.LstCategoriasModulos = Array.from(new Set(this.passCard.LstModulos.map(s => s.IdCategoriaModulo))).map(
        id => {
          return {
            IdCategoriaModulo: id,
            strCategoriaModulo: this.passCard.LstModulos.find(s => s.IdCategoriaModulo === id).strCategoriaModulo,
            LstModulos: this.passCard.LstModulos.filter(f => f.IdCategoriaModulo === id),
            opened: false
          };
        }
      );
    }
    this.cargarCredenciales();
  }

  public login(usuario: string, constrasenia: string): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {

      const cargando = await this.mensajesService.presentLoadingWithOptionsInfinite('Espere por favor...');
      cargando.present();
      this.p_getGenerarToken(usuario, constrasenia)
        .subscribe(async objTokenResult => {
          // console.log({ objTokenResult });




          this.passCard = new PassCard('', '');
          this.passCard.expirationDateToken = objTokenResult.ExpirationDateToken;
          this.passCard.idUser = objTokenResult.IdUserWMS;
          this.passCard.issuedDate = objTokenResult.IssuedDate;
          this.passCard.tokenData = objTokenResult.TokenData;
          this.passCard.tokenType = objTokenResult.TokenType;
          this.passCard.LstModulos = objTokenResult.LstModulos;
          this.passCard.usuario = objTokenResult.NombreUsuario;
          this.passCard.IdIdioma = objTokenResult.IdIdioma;
          this.passCard.blnTerminosCondiciones = objTokenResult.blnTerminosCondiciones;
          this.passCard.blnCambiarPassword = objTokenResult.blnCambiarPassword;
          this.passCard.IdPerfil = objTokenResult.IdPerfilWMS;


          this.passCard.LstCategoriasModulos = Array.from(new Set(this.passCard.LstModulos.map(s => s.IdCategoriaModulo))).map(
            id => {
              return {
                IdCategoriaModulo: id,
                strCategoriaModulo: this.passCard.LstModulos.find(s => s.IdCategoriaModulo === id).strCategoriaModulo,
                LstModulos: this.passCard.LstModulos.filter(f => f.IdCategoriaModulo === id),
                opened: false
              };
            }
          );


          const resultado = await this.guardarCredenciales();
          cargando.dismiss();
          if (resultado) {
            // await this.mensajesProvider.presentToast('ok login' + resultado);
            resolve(true);
          } else {
            // await this.mensajesProvider.presentToast('err login' + resultado);
            resolve(false);
          }

        },
          async error => {
            cargando.dismiss();
            this.passCard = undefined;
            // await this.mensajesProvider.presentToast('error login' + JSON.stringify(error));
            const continuar = await this.httpApiService.manejadorErroresApi(error);
            resolve(false);
          },
        );
    });
  }

  public getAceptarTerminosCondiciones(): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      // resolve(true);
      this.p_getAceptarTerminosCondiciones()
        .subscribe(async objTokenResult => {
          // console.log({ objTokenResult });
          resolve(objTokenResult);
        },
          error => {
            resolve(false);
            this.httpApiService.manejadorErroresApi(error);
          }
        );
    });
  }

  public ServiciosActivos(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.getServiciosActivos()
        .subscribe((objResultado) => {
          if (!!objResultado) {
            resolve(true);
          } else {
            resolve(false);
          }
        }, (error) => {
          this.httpApiService.manejadorErroresApi(error);
          resolve(false);
        });
    });
  }

  private p_getGenerarToken(usuario: string, constrasenia: string): Observable<WMSToken> {
    const pass = encodeURIComponent(constrasenia);
    const strPredicado =
      `Autorizacion/GenerarTokenLogin?usuario=${usuario}&contrasenia=${pass}&intDiasDeValides=${this.ajustesProvider.ajustes.diasValidezToken
      }`;
    //return this.httpApiService.ejecutarGetQuery(this.ajustesProvider.ajustes.wmsApiUrl, strPredicado);
    return this.httpApiService.ejecutarGetQuery<any>(this.ajustesProvider.ajustes.wmsApiUrl, strPredicado).pipe(
      map(result => {
        // Log the result to check the structure
        console.log('Result from API:', result);

        // Desencriptar los campos necesarios
        const decryptedData: Partial<WMSToken> = {
          blnCambiarPassword: this.CryptoProvider.decryptData(result.blnCambiarPassword) == 'true',//result.blnCambiarPassword,//
          ExpirationDateToken: new Date(this.CryptoProvider.decryptData(result.ExpirationDateToken)),//result.expirationDateToken,//undefined
          FechaBloqueo: new Date(this.CryptoProvider.decryptData(result.FechaBloqueo)),//result.FechaBloqueo,//
          FechaPasswordUltimo: new Date(this.CryptoProvider.decryptData(result.FechaPasswordUltimo)),//result.FechaPasswordUltimo,//
          IdPerfilWMS: parseInt(this.CryptoProvider.decryptData(result.IdPerfilWMS)),//result.IdPerfilWMS,//
          IdUser: parseInt(this.CryptoProvider.decryptData(result.IdUser)),//result.idUser,//undefined
          IdUserWMS: parseInt(this.CryptoProvider.decryptData(result.IdUserWMS)),//result.IdUserWMS,//
          IdModule: parseInt(this.CryptoProvider.decryptData(result.IdModule)),//result.IdModule,//
          Intentos: parseInt(this.CryptoProvider.decryptData(result.Intentos)),//result.Intentos,//
          IssuedDate: new Date(this.CryptoProvider.decryptData(result.IssuedDate)),//new Date(this.decryptData(result.issuedDate)),//undefined
          IsNotBlocked: this.CryptoProvider.decryptData(result.IsNotBlocked) == 'true',//result.IsNotBlocked,//
          //IsValid: this.CryptoProvider.decryptData(result.IsValid) == 'true',//result.IsValid,//undefined
          //IdToken: parseInt(this.decryptData(result.IdToken)),//result.IdToken,//undefined
          LstModulos: this.decryptLstModulos(result.LstModulos), // Desencriptar LstModulos
          NombreUsuario: this.CryptoProvider.decryptData(result.NombreUsuario),//result.NombreUsuario,//
          StartPage: this.CryptoProvider.decryptData(result.StartPage),
          TokenData: this.CryptoProvider.decryptData(result.TokenData),//undefined
          blnTerminosCondiciones: result.blnTerminosCondiciones,//this.decryptData(result.blnTerminosCondiciones) == 'true',//
          TokenType: result.tokenType,//parseInt(this.decryptData(result.tokenType)),//undefined
          Mensaje: result.mensajes,//parseInt(this.decryptData(result.mensajes)),//undefined
          IdIdioma: result.IdIdioma,//parseInt(this.decryptData(result.data.IdIdioma)),
        };

        // Log the decrypted data to verify
        //console.log('Decrypted Data:', decryptedData);

        return decryptedData as WMSToken; // Retornar el objeto WMSToken desencriptado
      }),
      catchError(error => {
        console.error('Error loading data:', error);
        throw error; // Propagar el error
      })
    );
  }

  private decryptLstModulos(encryptedLstModulos: any[]): itmMenu[] {
    if (!Array.isArray(encryptedLstModulos)) {
      throw new Error("Input must be an array");
    }
  
    return encryptedLstModulos.map(module => ({
      title: this.CryptoProvider.decryptData(module.title),
      component: this.CryptoProvider.decryptData(module.component),
      strIcono: module.strIcono,
      IdCategoriaModulo: Number(module.IdCategoriaModulo), // Asegúrate de que sea un número
      strCategoriaModulo: this.CryptoProvider.decryptData(module.strCategoriaModulo),
      selected: false // Inicializa como booleano
    }));
  }

  private p_getValidarPassAccion(contrasenia: string, IdAlmacen: number): Observable<boolean> {
    const pass =
      Md5.hashAsciiStr(`${this.ajustesProvider.ajustes.apiKey}${this.ajustesProvider.ajustes.realm}${contrasenia}`);
    const strPredicado =
      `Autorizacion/ValidarPassAccion?tokenData=${this.passCard.tokenData}&contrasenia=${pass}&IdAlmacen=${IdAlmacen}`;
    return this.httpApiService.ejecutarGetQuery(this.ajustesProvider.ajustes.wmsApiUrl, strPredicado);
  }

  private p_getAceptarTerminosCondiciones(): Observable<boolean> {
    if (this.passCard.tokenData) {
      const strPredicado =
        `Autorizacion/AceptarTerminosCondiciones?tokenData=${this.passCard.tokenData
        }`;
      return this.httpApiService.ejecutarGetQuery(this.ajustesProvider.ajustes.wmsApiUrl, strPredicado);
    }
  }

  private getServiciosActivos(): Observable<WMSToken> {
    const strPredicado = `cicsa/Ping`;
    return this.httpApiService.ejecutarGetQuery(this.ajustesProvider.ajustes.wmsApiUrl, strPredicado);
  }

  public manejadorErroresApiAuth(error: any) {
    this.httpApiService.manejadorErroresApi(error);
  }

  public logout(): Promise<boolean> {

    // Remove tokens and expiry time from localStorage
    const promesa = new Promise<boolean>((resolve, reject) => {

      // borrar del storage
      this.localDataService.boorrarLlavesLogOut().then(async () => {
        this.passCard = new PassCard('', '');
        this.navCtrl.navigateRoot('/log-in', { animated: true });
        resolve(true);
      }, err => {
        resolve(false);
      });

    });
    return promesa;
  }

  public guardarCredenciales(): Promise<boolean> {
    return this.localDataService.guardarLlave('passCard', this.passCard);
  }

  public cargarCredenciales(): Promise<boolean> {
    const promesa = new Promise<boolean>(async (resolve, reject) => {
      // leer del storage
      const clave = await this.localDataService.consultarLlave<PassCard>('passCard')

      if (clave) {
        if (new Date(clave.expirationDateToken) > new Date()) {
          this.passCard = clave;

          if (this.passCard.blnTerminosCondiciones === undefined) {
            this.passCard.blnTerminosCondiciones = false;
            this.guardarCredenciales();
          }
          if (this.passCard.blnCambiarPassword === undefined) {
            this.passCard.blnCambiarPassword = true;
            this.guardarCredenciales();

          }

          if (this.passCard.LstCategoriasModulos === undefined) {
            this.passCard.LstCategoriasModulos = Array.from(new Set(this.passCard.LstModulos.map(s => s.IdCategoriaModulo))).map(
              id => {
                return {
                  IdCategoriaModulo: id,
                  strCategoriaModulo: this.passCard.LstModulos.find(s => s.IdCategoriaModulo === id).strCategoriaModulo,
                  LstModulos: this.passCard.LstModulos.filter(f => f.IdCategoriaModulo === id),
                  opened: false
                };
              }
            );
            this.guardarCredenciales();
          }

          resolve(true);
        } else {
          this.passCard = undefined;
          resolve(false);
        }
      } else {
        this.passCard = undefined;
        resolve(false);
      }
    });
    return promesa;
  }

  public validaAccesoAccion(itmAccionesPorModulo: catAccionesPorModulo[], strAccionValidar: string): boolean {
    let blnResult = true;
    if (itmAccionesPorModulo) {
      if (itmAccionesPorModulo.length === 0) {
        return false;
      }
      const itmAccion: catAccionesPorModulo = itmAccionesPorModulo.find(f => this.CryptoProvider.decryptData(f.strNombre) === strAccionValidar);
      if (itmAccion) { blnResult = true; } else { blnResult = false; }
    }
    /*console.log(catAccionesPorModulo);
    console.log(strAccionValidar);
    console.log(blnResult);*/
    return blnResult;
  }

  public async authAdminPass(IdAlmacen: number): Promise<boolean> {
    let resolveLeaving;
    // const lstPassDirecto: number[] = [1];
    const canLeave = new Promise<boolean>(resolve => (resolveLeaving = resolve));

    const objMensageError = {
      message: 'Acceso denegado',
      position: 'bottom',
      duration: 1500,
      color: 'danger',
      buttons: [
        {
          icon: 'close-circle-outline',
          side: 'start',
          cssClass: 'warning'
        }
      ]
    };

    const strGetPass = await this.mensajesService.presentAlertPass();
    if (!!strGetPass && strGetPass.length > 0) {
      const cargando = await this.mensajesService.presentLoadingWithOptionsInfinite(`Validando…`);
      cargando.present();
      this.p_getValidarPassAccion(strGetPass, IdAlmacen).subscribe(data => {
        cargando.dismiss();
        if (data != null) {

          if (!!!data) {
            this.mensajesService.presentToastCustom(objMensageError);
          }

          resolveLeaving(data);
        } else {

          this.mensajesService.presentToastCustom(objMensageError);

          resolveLeaving(false);
        }
      }, error => {
        cargando.dismiss();
        this.httpApiService.manejadorErroresApi(error);
        this.mensajesService.presentToastCustom(objMensageError);
        resolveLeaving(false);
      });

    } else {
      this.mensajesService.presentToastCustom(objMensageError);
      resolveLeaving(false);
    }
    return canLeave;
  }

  async validaToken(): Promise<boolean> {
    return new Promise(async (resolve) => {

      // console.log('validaToken');

      await this.cargarCredenciales();
      await this.ajustesProvider.cargarAjustes();

      // console.log('validaToken', this.passCard);

      if (this.passCard === undefined) {

        // console.log('NAVIGATEROOT');


        this.navCtrl.navigateRoot('/log-in', { animated: true });
        return resolve(false);
      } else {
        return resolve(true);
      }
    });
  }
}
